﻿$.fn.dxCtrlCheckBox = function custom_dxCtrlCheckBox(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlcheckbox dx-ctrl");
        this.createInstance(new cdxCtrlCheckBox(this, option));
    }
    return this;
}

window.cdxCtrlCheckBox = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return dx.option(name);
        }
        else {
            option[name] = value;
            return dx.option(name, value);
        }
    }

    var dx = null;
    var $DivLabel = null;
    function mConstruit() {
        container.empty();

        if (typeof option.focusStateEnabled == 'undefined') option.focusStateEnabled = false

        if (typeof option.txtTooltip != 'undefined' && option.txtTooltip.length > 0) {
            container.attr("title", option.txtTooltip.remplacerTout("<br/>", "%cr%"))
            //tt = $("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: container, position: "top", contentTemplate: function (contentElement) { $("<div style='font-size:110%;'>" + option.txtTooltip + "</div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");
        }

        var onvaluechanged = option.onValueChanged
        option.onValueChanged = function (e) {
            if (option.disablePropagation && typeof e.event != "undefined") { e.event.preventDefault(); e.event.stopPropagation(); }
            if (typeof onvaluechanged != "undefined") onvaluechanged(e)
        }

        dx = $("<div/>").appendTo(container).dxCheckBox(option).dxCheckBox("instance")

        if (option.labelMode == "floating") {
            container.css({ "position": "relative", "padding-top": "5px", "min-height": "48px", "display": "flex" })
            $DivLabel = $('<div class="dx-texteditor-label" style="left: 0px;"><div class="dx-label-before" style="width: 0px;"></div><div class="dx-label"><span data-mark="">' + option.label + '</span></div><div class="dx-label-after"></div></div>').appendTo(container)
        }
    }

    mConstruit();

    this.component = function () { return dx; }
    this.element = function () { return container; }
}